// DOM Elements
const orderForm = document.getElementById('order-form');
const lineItemsContainer = document.getElementById('line-items-container');
const transactionsContainer = document.getElementById('transactions-container');
const discountCodesContainer = document.getElementById('discount-codes-container');

// Templates
const lineItemTemplate = document.createElement('template');
lineItemTemplate.innerHTML = `
    <div class="line-item">
        <h3>Line Item <span class="item-number"></span></h3>
        <div class="form-group">
            <label>Vendor*</label>
            <input type="text" name="vendor" required>
        </div>
        <div class="form-group">
            <label>Product ID*</label>
            <input type="text" name="productId" required>
        </div>
        <div class="form-group">
            <label>Variant ID*</label>
            <input type="text" name="variantId" required>
        </div>
        <div class="form-group">
            <label>Quantity*</label>
            <input type="number" name="quantity" min="1" value="1" required>
        </div>
        <div class="btn-container">
            <button type="button" class="btn-remove remove-line-item">Remove Line Item</button>
        </div>
    </div>
`;

const transactionTemplate = document.createElement('template');
transactionTemplate.innerHTML = `
    <div class="transaction">
        <h3>Transaction <span class="item-number"></span></h3>
        <div class="form-group">
            <label>Receipt Gateway*</label>
            <input type="text" name="receiptGateway" required>
        </div>
        <div class="form-group">
            <label>Status*</label>
            <input type="text" name="status" placeholder="success, pending, or failed" required>
        </div>
        <div class="form-group">
            <label>Amount*</label>
            <input type="number" name="amount" step="1" min="1" required>
        </div>
        <div class="form-group">
            <label>Kind*</label>
            <input type="text" name="kind" placeholder="authorization, capture, or refund" required>
        </div>
        <div class="form-group">
            <label>Gateway*</label>
            <input type="text" name="gateway" required>
        </div>
        <div class="form-group">
            <label>Authorization</label>
            <input type="text" name="authorization">
        </div>
        <div class="form-group">
            <label>Currency*</label>
            <input type="text" name="currency" value="INR" required>
        </div>
        <div class="form-group">
            <label>Source</label>
            <input type="text" name="source">
        </div>
        <div class="btn-container">
            <button type="button" class="btn-remove remove-transaction">Remove Transaction</button>
        </div>
    </div>
`;

const discountCodeTemplate = document.createElement('template');
discountCodeTemplate.innerHTML = `
    <div class="discount-code">
        <h3>Discount Code <span class="item-number"></span></h3>
        <div class="form-group">
            <label>Amount</label>
            <input type="number" name="discountAmount" step="1" min="1">
        </div>
        <div class="form-group">
            <label>Code</label>
            <input type="text" name="discountCode">
        </div>
        <div class="form-group">
            <label>Type</label>
            <input type="text" name="discountType" placeholder="fixed_amount or percentage">
        </div>
        <div class="btn-container">
            <button type="button" class="btn-remove remove-discount-code">Remove Discount Code</button>
        </div>
    </div>
`;

// Event Delegation for Remove Buttons
document.addEventListener('click', function(e) {
    if (e.target.classList.contains('remove-line-item')) {
        e.target.closest('.line-item').remove();
        updateItemNumbers(lineItemsContainer, 'Line Item');
    } else if (e.target.classList.contains('remove-transaction')) {
        e.target.closest('.transaction').remove();
        updateItemNumbers(transactionsContainer, 'Transaction');
    } else if (e.target.classList.contains('remove-discount-code')) {
        e.target.closest('.discount-code').remove();
        updateItemNumbers(discountCodesContainer, 'Discount Code');
    }
});

// Add Line Item
document.getElementById('add-line-item').addEventListener('click', function() {
    addItem(lineItemsContainer, lineItemTemplate, 'Line Item');
});

// Add Transaction
document.getElementById('add-transaction').addEventListener('click', function() {
    addItem(transactionsContainer, transactionTemplate, 'Transaction');
});

// Add Discount Code
document.getElementById('add-discount-code').addEventListener('click', function() {
    addItem(discountCodesContainer, discountCodeTemplate, 'Discount Code');
});

// Helper function to add items
function addItem(container, template, itemType) {
    const clone = template.content.cloneNode(true);
    const itemCount = container.children.length + 1;
    clone.querySelector('.item-number').textContent = itemCount;
    container.appendChild(clone);
}

// Helper function to update item numbers
function updateItemNumbers(container, itemType) {
    Array.from(container.children).forEach((item, index) => {
        item.querySelector('h3').textContent = `${itemType} ${index + 1}`;
    });
}

// Form submission with validation
orderForm.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Remove old error messages
    document.querySelectorAll('.field-error').forEach(el => el.remove());
    document.getElementById('error-message').style.display = 'none';

    let isValid = true;
    let firstInvalidField = null;
    const emptyFieldLabels = [];

    // Check required fields
    const requiredFields = orderForm.querySelectorAll('[required]');
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            showFieldError(field, `${getLabelText(field)} cannot be empty`);
            isValid = false;
            emptyFieldLabels.push(getLabelText(field).replace('*', '').trim());
            if (!firstInvalidField) firstInvalidField = field;
        }
    });

    // Validate email
    const emailField = document.getElementById('customer-email');
    if (emailField && emailField.value.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailField.value.trim())) {
            showFieldError(emailField, 'Please enter a valid email address');
            isValid = false;
            if (!firstInvalidField) firstInvalidField = emailField;
        }
    }

    // Validate phone (all phone fields)
    const phoneFields = orderForm.querySelectorAll('input[type="text"][id*="Phone"], input[name*="phone"]');
    phoneFields.forEach(phoneField => {
        if (phoneField.value.trim()) {
            const phoneRegex = /^\+?[0-9]{10,15}$/;
            if (!phoneRegex.test(phoneField.value.trim())) {
                showFieldError(phoneField, 'Please enter a valid phone number');
                isValid = false;
                if (!firstInvalidField) firstInvalidField = phoneField;
            }
        }
    });

    // If not valid, show summary error banner and scroll to first invalid field
    if (!isValid) {
        const errorMessageEl = document.getElementById('error-message');
        errorMessageEl.style.display = 'block';
        if (emptyFieldLabels.length > 0) {
            errorMessageEl.textContent = `Please fill the following required fields: ${emptyFieldLabels.join(', ')}`;
        } else {
            errorMessageEl.textContent = 'Please fix the errors highlighted above.';
        }
        if (firstInvalidField) {
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalidField.focus();
        }
        return;
    }

    // Show loading indicator
    document.getElementById('loading').style.display = 'block';
    document.getElementById('success-message').style.display = 'none';
    document.getElementById('error-message').style.display = 'none';

    try {
        const orderData = collectFormData();
        console.log('Order Data:', orderData);

        await submitOrderToAPI(orderData);

        document.getElementById('success-message').style.display = 'block';
        document.getElementById('loading').style.display = 'none';

        setTimeout(() => {
            orderForm.reset();
            document.getElementById('success-message').style.display = 'none';
            clearContainer(lineItemsContainer, lineItemTemplate, 'Line Item');
            clearContainer(transactionsContainer, transactionTemplate, 'Transaction');
            clearContainer(discountCodesContainer, discountCodeTemplate, 'Discount Code');
        }, 3000);
    } catch (error) {
        document.getElementById('loading').style.display = 'none';
        const errorEl = document.getElementById('error-message');
        errorEl.style.display = 'block';
        errorEl.textContent = 'Error: ' + error.message;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        console.error('Submission error:', error);
    }
});

// --- Validation Helpers ---
function showFieldError(field, message) {
    if (field.nextElementSibling && field.nextElementSibling.classList.contains('field-error')) return;
    const errorEl = document.createElement('div');
    errorEl.className = 'field-error';
    errorEl.style.color = 'red';
    errorEl.style.fontSize = '12px';
    errorEl.textContent = message;
    field.insertAdjacentElement('afterend', errorEl);
}

function getLabelText(field) {
    const label = field.closest('.form-group')?.querySelector('label');
    return label ? label.textContent.trim() : field.name || field.id;
}

// Helper function to clear container and add one default item
function clearContainer(container, template, itemType) {
    container.innerHTML = '';
    addItem(container, template, itemType);
}

// === Collect Form Data (unchanged) ===
function collectFormData() {
    const customer = {
        email: document.getElementById('customer-email').value,
        first_name: document.getElementById('firstName').value,
        last_name: document.getElementById('lastName').value
    };

    const shipping_address = {
        name: document.getElementById('shippingName').value,
        address1: document.getElementById('shippingAddress1').value,
        city: document.getElementById('shippingCity').value,
        province: document.getElementById('shippingProvince').value,
        zip: document.getElementById('shippingZip').value,
        country_code: document.getElementById('shippingCountryCode').value,
        country: document.getElementById('shippingCountry').value,
        phone: document.getElementById('shippingPhone').value
    };

    const billing_address = {
        name: document.getElementById('billingName').value,
        address1: document.getElementById('billingAddress1').value,
        city: document.getElementById('billingCity').value,
        province: document.getElementById('billingProvince').value,
        zip: document.getElementById('billingZip').value,
        country_code: document.getElementById('billingCountryCode').value,
        country: document.getElementById('billingCountry').value,
        phone: document.getElementById('billingPhone').value
    };

    const line_items = [];
    const lineItemElements = document.querySelectorAll('.line-item');
    lineItemElements.forEach((item) => {
        const variantValue = item.querySelector('[name="variantId"]').value.trim();
        const lineItem = {
            vendor: item.querySelector('[name="vendor"]').value,
            product_id: parseInt(item.querySelector('[name="productId"]').value),
            quantity: parseInt(item.querySelector('[name="quantity"]').value),
            applied_discounts: [],
            taxable: false,
            requires_shipping: true,
            discount_allocations: [],
            tax_lines: [{ rate: 0.18, price: "0.0000", title: "IGST" }],
            properties: {}
        };
        if (variantValue !== "") {
            lineItem.variant_id = parseInt(variantValue);
        }
        line_items.push(lineItem);
    });

    const transactions = [];
    const transactionElements = document.querySelectorAll('.transaction');
    transactionElements.forEach((transaction) => {
        transactions.push({
            receipt: { gateway: transaction.querySelector('[name="receiptGateway"]').value },
            status: transaction.querySelector('[name="status"]').value,
            amount: transaction.querySelector('[name="amount"]').value,
            kind: transaction.querySelector('[name="kind"]').value,
            gateway: transaction.querySelector('[name="gateway"]').value,
            authorization: transaction.querySelector('[name="authorization"]').value || "N/A",
            currency: transaction.querySelector('[name="currency"]').value,
            source: transaction.querySelector('[name="source"]').value || "external"
        });
    });

    const discount_codes = [];
    const discountCodeElements = document.querySelectorAll('.discount-code');
    discountCodeElements.forEach((discount) => {
        const amount = discount.querySelector('[name="discountAmount"]').value.trim();
        const code = discount.querySelector('[name="discountCode"]').value.trim();
        const type = discount.querySelector('[name="discountType"]').value.trim();
        if (amount || code || type) {
            discount_codes.push({
                amount: amount || null,
                code: code || null,
                type: type ? type.toUpperCase().replace(' ', '_') : null
            });
        }
    });

    const note_attributes = {
        CustomerGSTIN: document.getElementById('customerGSTIN').value,
        gstin_number: document.getElementById('gstinNumber').value,
        "Company Name": document.getElementById('companyName').value,
        "Breeze Order Id": document.getElementById('breezeOrderId').value
    };

    const additionalInfo = {
        inventory_behaviour: document.getElementById('inventoryBehavior').value || "decrement_obeying_policy",
        financial_status: document.getElementById('financialStatus').value || "paid",
        currency: document.getElementById('currency').value,
        tags: document.getElementById('tags').value,
        source_identifier: document.getElementById('sourceIdentifier').value || "Manual Creation",
        item_count: parseInt(document.getElementById('itemCount').value),
        phone: document.getElementById('shippingPhone').value,
        requires_shipping: true,
        taxes_included: true,
        send_receipt: true,
        cart_level_discount_applications: []
    };

    const order = {
        order: {
            ...additionalInfo,
            email: customer.email,
            phone: shipping_address.phone,
            line_items,
            transactions,
            billing_address,
            note_attributes,
            shipping_address,
            discount_codes,
            customer
        }
    };

    return order;
}

// === Error Parser Helper ===
function formatApiError(errorData, fallback) {
    if (!errorData) return fallback;

    // Check Shopify / Marmeto error structures:
    // 1. errorData.error.errors (e.g. {"error":{"errors":{"order":"Required parameter missing"}}})
    // 2. errorData.errors (e.g. {"errors":{"line_items":["variant not found"]}} or {"errors":"message"})
    const errorsObj = (errorData.error && errorData.error.errors) || errorData.errors;

    if (errorsObj) {
        if (typeof errorsObj === 'string') return errorsObj;
        if (Array.isArray(errorsObj)) return errorsObj.join(', ');
        if (typeof errorsObj === 'object') {
            const parts = [];
            for (const [key, val] of Object.entries(errorsObj)) {
                if (Array.isArray(val)) {
                    parts.push(`${key}: ${val.join(', ')}`);
                } else if (typeof val === 'object' && val !== null) {
                    parts.push(`${key}: ${JSON.stringify(val)}`);
                } else {
                    parts.push(`${key}: ${val}`);
                }
            }
            if (parts.length > 0) return parts.join(' | ');
        }
    }

    // 3. errorData.message (e.g. {"message": "..."})
    if (typeof errorData.message === 'string' && errorData.message.trim()) {
        return errorData.message;
    }

    // 4. errorData.error as string (e.g. {"error": "..."})
    if (typeof errorData.error === 'string' && errorData.error.trim()) {
        return errorData.error;
    }

    // 5. Fallback if object has other properties
    try {
        const str = JSON.stringify(errorData);
        if (str && str !== '{}') return str;
    } catch (_) {}

    return fallback;
}

// === Submit Order to API ===
async function submitOrderToAPI(orderData) {
    const API_URL = 'https://milton.marmeto.com/api/create-shopify-order';

    let response;
    try {
        response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orderData)
        });
    } catch (networkError) {
        // Fetch itself failed (no internet, DNS error, CORS, etc.)
        throw new Error('Network error: could not reach the server. Please check your connection.');
    }

    if (!response.ok) {
        // Try to read the error body; extract specific validation errors if available
        let fallbackMessage = `Server error: ${response.status} ${response.statusText}`;
        let errorMessage = fallbackMessage;
        try {
            const errorData = await response.json();
            errorMessage = formatApiError(errorData, fallbackMessage);
        } catch (_) {
            // Error body was not JSON — use the default status message above
        }
        throw new Error(errorMessage);
    }

    // Try to parse success response; if empty/non-JSON, just return gracefully
    try {
        return await response.json();
    } catch (_) {
        return { success: true };
    }
}


  const scriptURL = "https://script.google.com/macros/s/AKfycbzssicpTO4totqmZHSGNyrVQschrb4ptijzWcczHCHCIvptDQxrtU8DbXyWqLFex8Eo/exec"; // replace with deployed URL
  const form = document.getElementById('login-form');
  const wrapper = document.querySelector('.container.create-order-wrapper');
  const loginContainer = document.querySelector('.login-container');
  const loader = document.getElementById('loader');
  const loginBtn = document.getElementById('loginBtn');

  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();

    loader.classList.remove('hidden');
    loginBtn.disabled = true;

    const payload = new URLSearchParams();
    payload.append('firstName', document.getElementById('firstName').value.trim());
    payload.append('lastName',  document.getElementById('lastName').value.trim());
    payload.append('email',     document.getElementById('email').value.trim());
    payload.append('password',  document.getElementById('password').value);

    try {
      const res = await fetch(scriptURL, { method: 'POST', body: payload });
      let data;
      const ct = res.headers.get('content-type') || '';
      if (ct.indexOf('application/json') !== -1) {
        data = await res.json();
      } else {
        const text = await res.text();
        try { data = JSON.parse(text); } catch(e) { data = { success:false, message:text }; }
      }

      if (data.success) {
        loginContainer.style.display = 'none';
        wrapper.classList.remove('hidden');
      } else {
        alert('Invalid credentials: ' + (data.message || 'unknown'));
        window.location.href = '/';
      }
    } catch (err) {
      console.error(err);
      alert('Error logging in.');
    } finally {
      loader.classList.add('hidden');
      loginBtn.disabled = false;
    }
  });